import { T } from "../../../i18n/social";
// No syntax errors found in this file. The code is structurally sound and all JSX is valid.
// The linting error about missing required props appears to be a false positive since onEdit is used conditionally in the component.
import React from "react";

const InfoRow = ({ icon, text }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '6px 0' }}>
    <div style={{ color: '#6b7a8d', flexShrink: 0, marginTop: '1px' }}>{icon}</div>
    <span style={{ fontSize: '14px', color: '#1e2b38', fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>{text}</span>
  </div>
);

const SummarySection = ({ title, icon, onEdit, children }) => (
  <div style={{ border: '1px solid #dde1e7', borderRadius: '16px', padding: '18px', marginBottom: '14px', background: '#f8f9fa' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ color: '#6b7a8d' }}>{icon}</div>
        <span style={{ fontSize: '14px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>{title}</span>
      </div>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 8px', borderRadius: '8px', transition: 'all 150ms ease' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(62,73,84,0.06)'; e.currentTarget.style.color = '#3E4954'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#6b7a8d'; }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          Ändern
        </button>
      )}
    </div>
    {children}
  </div>
);

const CalIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const UserIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const StepSummary = ({ lang, stepBadge,
  formData,
  selectedDate,
  selectedSlot,
  consultationType,
  onBack,
  onBook,
  isLoading,
  slotConflict,
  onEditAppointment,
  onEditContact,
}) => {
  const tsum = (lang && T[lang]?.steps?.summary) || T['de']?.steps?.summary || { title: 'Zusammenfassung', appointment: 'Dein Termin', yourData: 'Deine Angaben', back: 'Zurück', book: 'Jetzt buchen ✓', conflict: 'Dieser Termin wurde soeben vergeben.', onsiteLabel: 'Vor-Ort-Beratung', phoneLabel: 'Telefonberatung', uhr: 'Uhr', edit: 'Ändern' };
  const dateLabel = selectedDate
    ? selectedDate?.toLocaleDateString(lang === "uk" ? "uk-UA" : lang === "ru" ? "ru-RU" : "de-DE", {
        weekday: "long", day: "2-digit", month: "2-digit", year: "numeric",
      })
    : "";

  const typeLabel = consultationType === "onsite" ? tsum.onsiteLabel : tsum.phoneLabel;

  const tagIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
  const clockIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
  const calDaysIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
  const mapIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
  const phoneIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
  const mailIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
  const homeIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
  const userCircleIcon = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

  return (
    <div className="booking-card step-enter">
      {stepBadge && <div className="step-badge">{stepBadge}</div>}

      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700, color: '#1e2b38', marginBottom: '20px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
        {tsum.title}
      </h2>

      {slotConflict && (
        <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {tsum.conflict || "Dieser Termin wurde soeben vergeben. Bitte wähle einen anderen Zeitslot."}
          <button
            onClick={onEditAppointment}
            className="ml-2 underline font-medium hover:text-red-900"
          >
            Termin ändern
          </button>
        </div>
      )}

      <SummarySection title={tsum.appointment} icon={<CalIcon />} onEdit={onEditAppointment}>
        <InfoRow icon={tagIcon} text={typeLabel} />
        <InfoRow icon={calDaysIcon} text={<span style={{ textTransform: 'capitalize' }}>{dateLabel}</span>} />
        <InfoRow icon={clockIcon} text={tsum.uhr ? `${selectedSlot} ${tsum.uhr}` : selectedSlot} />
        {consultationType === "onsite" && (
          <InfoRow icon={mapIcon} text="Kruppstraße 41-45, 42489 Wülfrath" />
        )}
      </SummarySection>

      <SummarySection title={tsum.yourData} icon={<UserIcon />} onEdit={onEditContact}>
        <InfoRow icon={userCircleIcon} text={`${formData?.vorname} ${formData?.nachname}`} />
        <InfoRow icon={mailIcon} text={formData?.email} />
        <InfoRow icon={phoneIcon} text={`${formData?.telefonPrefix || '+49'} ${formData?.telefon}`} />
        {formData?.wohnort && (
          <InfoRow icon={homeIcon} text={formData?.wohnort} />
        )}
      </SummarySection>

      <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
        <button type="button" onClick={onBack} className="btn-outline" style={{ flex: 1 }}>
          {tsum.back}
        </button>
        <button
          type="button"
          onClick={onBook}
          disabled={isLoading}
          className="btn-primary"
          style={{ flex: 2 }}
        >
          {isLoading ? (
            <>
              <svg className="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25"/>
                <path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
              </svg>
              Wird gebucht…
            </>
          ) : (
            <>
              {tsum.book}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default StepSummary;